import { type FC, Suspense } from 'react';
import { ProductAddonsIsland, type ProductAddonsIslandProps } from './ProductAddonsIsland';
import { ProductAddonsIslandStub } from './ProductAddonsIslandStub';

export const ProductAddonsIslandSuspense: FC<ProductAddonsIslandProps> = (props) => (
    <Suspense fallback={<ProductAddonsIslandStub />}>
        <ProductAddonsIsland {...props} />
    </Suspense>
);
